/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Keyword_SportsInputs */



/**
* | output |
* | --- |
* | "Sports" |
*
* @param {Subtitle_Export_Keyword_SportsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_keyword_sports = /** @type {((inputs?: Subtitle_Export_Keyword_SportsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Keyword_SportsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sportif")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sport")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Спорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deportes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("运动的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スポーツ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खेल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esportes")
	return /** @type {LocalizedString} */ ("Sports")
});